import {
  Link,
  Box,
  Text,
  IconSocialFacebook32,
  IconSocialInstagram32,
  IconSocialLinkedin32,
  IconButton,
  Inline,
} from '@stitch-fix/mode-react';
import classNames from 'classnames';
import styles from './style.module.scss';
import type { CloudinaryImageFields } from '../CloudinaryImageWrapper/CloudinaryImageWrapper';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import { MODE_LEGACY_MIN_WIDTH } from '../../utils/values/mediaQueries';

export type FollowUsProps = {
  title: string;
  subtitle: string;
  images: (Pick<CloudinaryImageFields, 'alt' | 'src' | 'cloudinaryAsset'> & {
    name?: string;
  })[];
  showSocialIcons?: boolean;
  bgColor?: string;
};

export const FollowUs = ({
  title,
  subtitle,
  images,
  showSocialIcons,
  bgColor,
}: FollowUsProps) => {
  return (
    <Box
      as="section"
      m="0 auto"
      p={showSocialIcons ? '1.5rem 0 1.875rem' : '0.4rem 0 1.5rem'}
      maxWidth={!showSocialIcons ? '100%' : 'auto'}
      style={{ backgroundColor: bgColor }}
      className={!showSocialIcons ? classNames(styles['left-aligned']) : ''}
    >
      <Box
        m="0 auto"
        className={`${styles.container} ${
          !showSocialIcons ? classNames(styles['less-max-width']) : ''
        }`}
      >
        <Text
          setting="title-medium"
          as="h2"
          className={classNames(styles.title)}
        >
          {title}
        </Text>
        <Text
          as="p"
          family="regular"
          height="standard"
          scale="3"
          className={classNames(styles.subtitle)}
        >
          {subtitle}
        </Text>
        <Box
          maxWidth={{ sm: '355px', md: '355px', lg: '1100px', xl: '1250px' }}
          m="0 auto"
          className={styles.images}
        >
          {images.map((image, imageIndex) => (
            <Box
              p={0}
              maxWidth="175px"
              mb={1.125}
              className={styles.image}
              key={image.src}
            >
              {
                // on non careers pages link to instagram
                !showSocialIcons ? (
                  <Link href="https://www.instagram.com/stitchfix">
                    <CloudinaryPicture
                      alt={image.alt}
                      sources={[
                        {
                          minWidth: 0,
                          // images 4 and 5 are hidden in mobile
                          cloudinaryAsset:
                            imageIndex === 3 || imageIndex === 4
                              ? undefined
                              : image.cloudinaryAsset,
                          sizes: [{ minWidth: 0, staticWidth: 182 }],
                        },
                        {
                          minWidth: MODE_LEGACY_MIN_WIDTH.sm,
                          cloudinaryAsset: image.cloudinaryAsset,
                          sizes: [{ minWidth: 0, staticWidth: 182 }],
                        },
                      ]}
                      imageProps={{ loading: 'lazy' }}
                    />
                  </Link>
                ) : (
                  <CloudinaryPicture
                    alt={image.alt}
                    sources={[
                      {
                        minWidth: 0,
                        // images 4 and 5 are hidden in mobile
                        cloudinaryAsset:
                          imageIndex === 3 || imageIndex === 4
                            ? undefined
                            : image.cloudinaryAsset,
                        sizes: [{ minWidth: 0, staticWidth: 182 }],
                      },
                      {
                        minWidth: MODE_LEGACY_MIN_WIDTH.sm,
                        cloudinaryAsset: image.cloudinaryAsset,
                        sizes: [{ minWidth: 0, staticWidth: 182 }],
                      },
                    ]}
                    imageProps={{ loading: 'lazy' }}
                  />
                )
              }
              {image.name && (
                <em>
                  <Text align="left" mt={0.5}>
                    {image.name}
                  </Text>
                </em>
              )}
            </Box>
          ))}
        </Box>
        {showSocialIcons && (
          <Box className={styles['social-icons-container']}>
            <Inline spacing="20px">
              <IconButton
                as="a"
                href="https://www.facebook.com/LifeatStitchFix"
                rel="noopener noreferrer"
                aria-label="facebook"
                variant="knockout"
              >
                <IconSocialFacebook32 purpose="decorative" color="white" />
              </IconButton>
              <IconButton
                as="a"
                href="https://www.instagram.com/lifeatstitchfix/"
                rel="noopener noreferrer"
                aria-label="instagram"
                variant="knockout"
              >
                <IconSocialInstagram32 purpose="decorative" color="white" />
              </IconButton>
              <IconButton
                as="a"
                href="https://www.linkedin.com/company/stitch-fix/jobs/"
                rel="noopener noreferrer"
                aria-label="linkedin"
                variant="knockout"
              >
                <IconSocialLinkedin32 purpose="decorative" color="white" />
              </IconButton>
            </Inline>
          </Box>
        )}
      </Box>
    </Box>
  );
};
